import { Component, ElementRef, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import * as $ from 'jquery'
import 'datatables.net';
import 'datatables.net-bs4';
import { DataServiceService } from 'src/app/data-service.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { WifiserviceService } from '../wifiservice.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { delay, map, startWith } from 'rxjs/operators';
import { AsyncPipe } from '@angular/common';
import { ErrorService } from 'src/app/error.service';
import { MatDialog } from '@angular/material/dialog';
import { AlertComponent } from 'src/app/alert/alert.component';
import { MatSelect } from '@angular/material/select';
import { MatInput } from '@angular/material/input';
import { of } from 'rxjs';
import { NgDialogAnimationService } from 'ng-dialog-animation';
import { WifistudentDialogComponent } from '../wifistudent-dialog/wifistudent-dialog.component';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';

// Define an interface to match the expected data structure
interface table {
  studentName: string;
  admNo: number;
  examProgram: number;
  programName: string;
  section: string;
  className: string;
  dob: string;
}


@Component({
  selector: 'app-wifi-student-details',
  templateUrl: './wifi-student-details.component.html',
  styleUrls: ['./wifi-student-details.component.scss']
})
export class WifiStudentDetailsComponent implements OnInit {

  displayedColumns: string[] = [
    'select','studentName', 'admNo', 'examProgram', 'programName', 'section', 
    'className', 'dob','view'
  ];
  dataSource = new MatTableDataSource<table>([]);

  myForm!: FormGroup;
  selectAllChecked = false;
  selectedItems: any[] = [];

  payload: any;

  event: any;
  states: any;
  citys: any;
  campuses: any;
  Building: any;
  wifidetails: any;
  table: any;
  saveDetails: any

  // filter data//

  stateID: any;
  statename: any = new FormControl();
  cityID: any;
  cityname: any = new FormControl();
  campusname: any = new FormControl();
  campusID: any;
  buildingID: any;
  wifiID: any;
  wifiname: any;
  buildingnames: any = new FormControl();
  wifinames: any = new FormControl();
  stateOptions: any;
  cityoption: any
  campusoption: any;
  buildingoption: any;
  wifioption: any;
  statename1: any;
  cityname1: any;
  campusname1: any;
  buildingnames1: any;
  studentPayload: any[] = [];

  @ViewChild('matSelect') matSelect: MatSelect;




  constructor(private wifiService: WifiserviceService, private dialog: MatDialog, private errorService: ErrorService, private spinner: NgxSpinnerService, private fb: FormBuilder, public dialog1: NgDialogAnimationService) {

  }



  ngOnInit(): void {
    this.tabledata();
    this.statedata();

    this.myForm = this.fb.group({
      state: ['', Validators.required],
      city: ['', Validators.required],
      campus: ['', Validators.required],
      building: ['', Validators.required],
      wifi: ['', Validators.required]
    });


  }
  // filter Method //

  private _filter(value: string, list: any[], name: any): any[] {
    const filterValue = value.trim().toLowerCase();
    return list.filter((option: any) => option[name] && option[name].toLowerCase().includes(filterValue));
  }


  headdata = [
    {
      admNo: 'Adm No', examProgram: 'Exam Program', className: 'Class Name', dob: "Date of Birth"
      , programName: 'Program Name', section: 'Section', studentName: 'Student Name', view: 'View'
    }
  ]



  statedata() {
    this.spinner.show();
    this.wifiService.getstate().subscribe({
      next: (res: any) => {
        this.states = res;
        this.spinner.hide();
        this.stateOptions = this.statename.valueChanges.pipe(
          startWith(''),
          map((value: any) => this._filter(value, this.states, 'stateName' )),
        );
      },
      error: (error: any) => {
        this.spinner.hide();
        this.errorService.errorDisplay(Number(error.status), "Error", "State Details");
      }



    });
  }


  getcity(state: any) {
    this.stateID = state.stateId
    this.statename1 = state.stateName
    this.spinner.show();
    this.wifiService.getcity(this.stateID).subscribe({
      next: (res: any) => {
        this.citys = res;
        this.spinner.hide();
        // filter option List //
        this.cityoption = this.cityname.valueChanges.pipe(
          startWith(''),
          map((value: any) => this._filter(value, this.citys, 'cityName' )),
        );
      },
      error: (error: any) => {
        this.spinner.hide();
        this.errorService.errorDisplay(Number(error.status), 'Error', 'City Details');
      }
    })
  }

  getcampus(city: any) {
    this.cityID = city.cityId;
    this.cityname1 = city.cityName;
    this.spinner.show();
    this.wifiService.getcampus(this.cityID).subscribe({
      next: (res: any) => {
        this.campuses = res;
        this.spinner.hide();
        this.campusoption = this.campusname.valueChanges.pipe(
          startWith(''),
          map((value: any) => this._filter(value, this.campuses, 'campusName' )),
        );
      },
      error: (error: any) => {
        this.spinner.hide();
        this.errorService.errorDisplay(Number(error.status), 'Error', 'Campus Details');
      }
    })

  }

  getbuliding(camp: any) {
    this.campusID = camp.campusId;
    this.campusname1 = camp.campusName;
    this.spinner.show();
    this.wifiService.getbuliding(this.campusID).subscribe({
      next: (res: any) => {
        this.Building = res;
        this.spinner.hide();
        this.buildingoption = this.buildingnames.valueChanges.pipe(
          startWith(''),
          map((value: any) => this._filter(value, this.Building, 'buildingName' )),
        );
      },
      error: (error: any) => {
        this.spinner.hide();
        this.errorService.errorDisplay(Number(error.status), 'Error', 'Building Details');
      }
    })
  }


  gettable(wifi: any) {
    this.wifiID = wifi.ssids;
    this.wifiname = wifi.ssidName;
    this.spinner.show();
    this.wifiService.gettable(this.buildingID).subscribe({
      next: (res: any) => {
        this.table = res;
        this.spinner.hide();
        $('#studenttables').DataTable().destroy();
        this.tabledata();
      },
      error: (error: any) => {
        this.spinner.hide();
        this.errorService.errorDisplay(Number(error.status), 'Error', 'Table Details');
      }
    });
  }

  getwifilist(buil: any) {
    this.buildingID = buil.buildingId;
    this.buildingnames1 = buil.buildingName;
    this.spinner.show();
    this.wifiService.getwifiname(this.buildingID).subscribe({
      next: (res: any) => {
        this.wifidetails = res;
        this.spinner.hide();
        this.wifioption = this.wifinames.valueChanges.pipe(
          startWith(''),
          map((value: any) => this._filter(value, this.wifidetails, 'ssidName')),
        );
      },
      error: (error: any) => {
        this.spinner.hide();
        this.errorService.errorDisplay(Number(error.status), 'Error', error.error.message);
      }
    });
  }



  tabledata() {

    $(document).ready(() => {
      $('#studenttables').DataTable({
      });
    });
  }

  toggleSelectAll(event: any) {
    this.selectAllChecked = event.target.checked;

    if (this.selectAllChecked) {
      this.selectedItems = this.table;
    } else {
      this.selectedItems = [];
    }
  }

  studentSelect(data: any) {
    if (this.selectedItems.includes(data)) {
      this.selectedItems = this.selectedItems.filter(item => item !== data);
    } else {
      this.selectedItems.push(data);

    }
  }

  onSubmit() {
    if (this.myForm.valid) {
      this.payload;
      for (let i = 0; i < this.selectedItems.length; i++) {
        const studentdata = {
          "admNo": this.selectedItems[i].admNo,
          "name": this.selectedItems[i].studentName,
          "dob": this.selectedItems[i].dob,
          "password": ''
        }
        this.studentPayload.push(studentdata);
      }
      var data = {
        "buildingId": this.buildingID,
        "stateId": this.stateID,
        "stateName": this.statename1,
        "cityId": this.cityID,
        "cityName": this.cityname1,
        "campusId": this.campusID,
        "campusName": this.campusname1,
        "studentList": this.studentPayload,
        "merakiSsidDetails": [
          {
            "ssids": this.wifiID,
            "ssidName": this.wifiname
          }
        ]
      }
      this.payload = data;
      this.spinner.show();
      this.wifiService.wifisave(this.payload).subscribe(
        {
          next: (res) => {
            this.saveDetails = res;
            this.studentPayload = [];
            this.payload = [];
            this.spinner.hide();
            console.log('save', this.saveDetails.message);
            this.errorService.errorDisplay(200, 'Success', '');
            this.selectedItems = [];
          },
          error: (error) => {
            this.spinner.hide();
            console.log('error', error);
            this.errorService.errorDisplay(Number(error.status), 'Error', 'Save Details');
          },
          complete: () => {
            console.log('completed !');

          }
        }
      );
    } else {
      this.errorService.errorDisplay(108, "Warning", '');
    }
  }


  stateinput(select: MatSelect) {
    this.statename.setValue(" ");
    if (this.matSelect) {
      this.matSelect.open();

    }
  }

  cityinput(select: MatSelect) {
    this.cityname.setValue('');
    if (this.matSelect) {
      this.matSelect.open();
    }
  }

  campusinput(select: MatSelect) {
    this.campusname.setValue('');
    if (this.matSelect) {
      this.matSelect.open();
    }
  }

  buildinginput(select: MatSelect) {
    this.buildingnames.setValue('');
    if (this.matSelect) {
      this.matSelect.open();
    }
  }

  wifiinput(select: MatSelect) {
    this.wifinames.setValue('');
    if (this.matSelect) {
      this.matSelect.open();
    }
  }

  //List clear in fliter //

  clearcity() {
    this.myForm.get('city')?.reset();
    this.cityoption = of([]).pipe(delay(0));
    this.clearcampus()
  }
  clearcampus() {
    this.myForm.get('campus')?.reset();
    this.campusoption = of([]).pipe(delay(0));
    this.clearbuliding()
  }

  clearbuliding() {
    this.myForm.get('building')?.reset();
    this.buildingoption = of([]).pipe(delay(0));
    this.clearwifi()
  }
  clearwifi() {
    this.myForm.get('wifi')?.reset();
    this.wifioption = of([]).pipe(delay(0));
    this.cleartable()
  }
  cleartable() {
    this.table = [];
    $('#studenttables').DataTable().destroy();
    this.tabledata();
  }

  studentwifi(data: any) {
    data.stateID = this.stateID
    data.stateName = this.statename1
    data.cityID = this.cityID
    data.cityName = this.cityname1
    data.campusID = this.campusID
    data.campusName = this.campusname1
    data.wifiID = this.wifiID
    data.wifiName = this.wifiname
    data.buildingID = this.buildingID
    // data.buildingName = this.buildingnames1

    console.log('wifi', data);
    let dialogRef = this.dialog1.open(WifistudentDialogComponent, <any>{
      data: data,
      disableClose: true,
      direction: 'ltr',
      height: '100%',
      width: '30%',
      position: { right: '0px', top: '0px' },
      animation: { to: "left" },
    });

  }

}






